import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaSeedling,
    FaWater,
    FaRecycle,
    FaLeaf,
    FaBug,
    FaGlobeAsia
} from "react-icons/fa";

const ecoData = [
    {
        icon: <FaSeedling />,
        title: "Soil Health Protection",
        text: "Our solutions improve soil structure and fertility while preserving beneficial microorganisms.",
        image: "/images/img/eco-soil.png",
    },
    {
        icon: <FaWater />,
        title: "Water Resource Safety",
        text: "Eco-conscious formulations help protect groundwater and maintain water quality.",
        image: "/images/img/eco-water.jpg",
    },
    {
        icon: <FaRecycle />,
        title: "Reduced Chemical Dependency",
        text: "We promote farming practices that minimize excessive use of harsh chemical inputs.",
        image: "/images/img/eco-chemical.jpg",
    },
    {
        icon: <FaLeaf />,
        title: "Biodegradable Solutions",
        text: "Products designed to break down naturally without harming crops or the environment.",
        image: "/images/img/eco-biodegradable.jpg",
    },
    {
        icon: <FaBug />,
        title: "Protection of Beneficial Life",
        text: "Our approach safeguards helpful insects and soil organisms essential for agriculture.",
        image: "/images/img/eco-insects.jpg",
    },
    {
        icon: <FaGlobeAsia />,
        title: "Sustainable Future Focus",
        text: "Responsible agriculture today ensures food security and environmental balance tomorrow.",
        image: "/images/img/eco-future.jpg",
    },
];

const EcoCommitment = () => {
    return (
        <section className="section eco-section">
            <Container>

                {/* Section Heading (Common CSS reused) */}
                <div className="section-title fade-up">
                    <h2>Eco-Friendly Commitment</h2>
                    <p>
                        Farming in harmony with nature while ensuring productivity,
                        soil health, and long-term agricultural sustainability.
                    </p>
                </div>

                <Row>
                    {ecoData.map((item, index) => (
                        <Col lg={4} md={6} className="mb-4 fade-up" key={index}>
                            <div className="eco-card">

                                <div className="eco-image">
                                    <img src={item.image} alt={item.title} />
                                </div>

                                <div className="eco-content">
                                    <div className="eco-icon">{item.icon}</div>
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>

                            </div>
                        </Col>
                    ))}
                </Row>

            </Container>
        </section>
    );
};

export default EcoCommitment;
